<template>
  <div class="chart_body" v-if="isBody">
    <div class="chart_gif" v-show="!visible_body" @click="remove">
      <img
        src="https://home.zhongzhiapp.com/public/storage/image/20231208/34a3c4cf9d84374c7cc085a954640810.png"
        alt
        width="106px"
        height="106px"
      />
    </div>
    <div
      :class="['footer', footer_status == true ? 'max_footer' : 'min_footer']"
      v-show="visible_body"
    >
      <div class="chat_all">
        <div class="chat_top">
          <span class="top_reduce" @click="minOrMax()">
            <!-- {{ footer_status ? '缩小' : '放大' }} -->
            <i class="el-icon-copy-document icon"></i>
          </span>
          <div class="center_p">
            <p class="marquee">{{ affichelist }}</p>
          </div>
       
          <span class="top_esc" @click="remove">
            <!-- 关闭 -->
            <i class="el-icon-close icon"></i>
          </span>
        </div>

        <div class="chat_content" ref="chat_content">
          <ul class="message_ul">
            <li
              v-for="(item, index) in messageList"
              :key="index"
              :class="[item.type == 2 ? 'left_li' : 'right_li']"
            >
              <img
                v-if="item.type == 2"
                src="https://home.zhongzhiapp.com/public/static/images/aitx.png"
                alt
              />
              <p v-html="item.text.replace(/\n/g, '<br />')"></p>
              <img class="my_img" v-if="item.type == 1" :src="userInfo.avatar" alt />
            </li>
          </ul>
        </div>

        <div class="chat_bottom">
          <div class="bottom_ne"></div>
          <el-input class="bottom_content" v-model="parameter" placeholder="想对TA问点什么呢？" />
          <el-button type="primary" class="bottom_button" @click="Submit" :disabled="disabled">发送</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const baseUrl = "https://home.zhongzhiapp.com/public/index.php";
export default {
  name: "ChatGpt",
  data() {
    return {
      isOneVisible: false,
      timer: null,
      messageTimer: null,
      parameter: "",
      messageList: [],
      visible_body: false,
      footer_status: false,
      disabled: false, //按钮
      affiche: true, //公告开关
      affichelist: "", //公告内容
      isBody: false
    };
  },
  created() {},
  watch: {
    isOneVisible(newVal) {
      this.QueryDialogue();
    }
  },
  computed: {
    userInfo() {
      if (JSON.parse(localStorage.getItem('userInfo_')) != null) {
        const { user } = JSON.parse(localStorage.getItem('userInfo_'));
        return user
      } else {
        return {
          avatar: 'https://home.zhongzhiapp.com/public/static/images/头像.png'
        }
      }
    }
  },
  methods: {
    setScroll() {
      this.$refs.chat_content.scrollTo(0, this.$refs.chat_content.scrollHeight);
    },
    remove() {
      this.isOneVisible = true;
      this.visible_body = !this.visible_body;

      // if (this.userInfo.id != "" && this.messageList.length == 0) {
      //   this.QueryDialogue(this.userInfo.id);
      // }
    },
    Submits() {
      console.log("成功");
    },
    minOrMax() {
      this.footer_status = !this.footer_status;
    },
    Submit() {
      console.log(this.userInfo, '123');
      if (this.messageTimer != null) {
        clearInterval(this.messageTimer);
      }
      if (this.parameter == "") {
        this.$message({
          message: "请输入问题内容",
          type: "error"
        });
        return false;
      }

      this.disabled = true; //发送按钮禁止
      this.messageList.push({
        text: this.parameter,
        type: 1,
        img_url: "../../static/aitx2.gif"
      });

      this.setScroll();
      this.setPoint();
      let data = {
        content: this.parameter, //问题
        user_id: this.userInfo.id, //用户id
        nickname: this.userInfo.nickname,
        identity: this.userInfo.identity, //是否会员
        type: 2 //1手机端 2pc端
      };
      this.$post(`${baseUrl}/Cchargpt/QueryCharGpt`, data).then(res => {
        if (res.code == 200) {
          this.parameter = ""; //文本框
          this.disabled = false; //按钮禁止
          clearInterval(this.timer);
          this.affichelist = "";
          this.setMessage(res.data.result); //打字机效果
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });

          this.disabled = false;
          clearInterval(this.timer);
          this.messageList[this.messageList.length - 1].text = res.msg;
          this.setMessage(res.msg);
        }
      });
    },
    //随机对话
    QueryDialogue(id) {
      this.getAffiche();
      let that = this;
      let data = {
        user_id: id
      };
      that.$post(`${baseUrl}/Cdialogue/QueryDialogue`, data).then(res => {
        if ((res.code = 200)) {
          let data = res.data.value;
          this.setMessage(data);
        }
      });
    },
    //打字机效果
    setMessage(data) {
      if (this.messageList.length == 0) {
        this.messageList.push({
          text: "",
          type: 2,
          img_url: "../../static/aitx2.gif"
        });
      }

      let currentIndex = 0;
      const typingSpeed = 100; // 打字速度，单位：毫秒
      this.messageTimer = setInterval(() => {
        this.messageList[this.messageList.length - 1].text +=
          data[currentIndex];
        currentIndex++;
        this.setScroll();
        if (currentIndex >= data.length) {
          clearInterval(this.messageTimer);
          this.messageTimer = null;
        }
      }, typingSpeed);
      this.messageList[this.messageList.length - 1].text = "";
    },
    // 设置消息返回前的交互
    setPoint() {
      this.affiche = true;
      let currentIndex = 0;
      const typingSpeed = 200; // 打字速度，单位：毫秒
      this.messageList.push({
        text: "",
        type: 2,
        img_url: "../../static/aitx2.gif"
      });
      let wenzi = "正在输入中...";
      this.timer = setInterval(() => {
        currentIndex++;
        if (currentIndex > 6) {
          this.messageList[this.messageList.length - 1].text = "";
          currentIndex = 0;
        }

        this.affichelist = wenzi.substring(0, currentIndex);
        this.messageList[this.messageList.length - 1].text += ".";
      }, typingSpeed);
    },
    //获取用户基本信息
    getUser() {
      let that = this;
      that.$get("auth/profile", "").then(res => {
        if (res.code == 1) {
          // that.userInfo = res.data;
          this.QueryDialogue(res.data.id);
        }
      });
    },
    //公告
    getAffiche() {
      let that = this;
      let data = {
        type: 2
      };
      that.$post(`${baseUrl}/Cconfig/QueryConfigType`, data).then(res => {
        console.log(res);
        if ((res.code = 200)) {
          if (res.data.value.switch == "1") {
            this.affiche = true;
            this.visibleAffiche(res.data.value.time);
          } else if (res.data.value.switch == "2") {
            this.affiche = false;
          }
          this.affichelist = res.data.value.affiche;
        }
      });
    },
    //公告显示时间
    visibleAffiche(second = 15) {
      let timer = setTimeout(() => {
        this.affiche = false;
        clearTimeout(timer);
      }, second * 1000);
    },
    // 获取是否显示
    getBodyStatus() {
      this.$post(`${baseUrl}/Cconfig/QueryImagesAi`, {
        type: 4
      }).then(res => {
        if (res.data.value == "1") {
          this.isBody = true;
        }
      });
    }
  },
  mounted() {
    
    this.getBodyStatus();
    // this.getUser();
   
  },
  unmounted() {
    clearInterval(this.messageTimer);
    clearInterval(this.timer);
  }
};
</script>

<style scoped lang="less">
@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  } /* 根据需要调整速度 */
}
.center_p {
  width: 88%;
  overflow: hidden;
}
.marquee {
  padding-left: 30px;
  white-space: nowrap;
  animation: marquee 10s linear infinite; /* 根据需要调整持续时间、速度曲线等参数 */
}

.my_img {
  width: 42px !important;
  height: 42px !important;
  border-radius: 50%;
  margin-top: 5px;
  margin-left: 7px;
}

.chart_gif {
  position: fixed;
  cursor: pointer;
  bottom: 70px;
  right: 70px;
  -webkit-animation: swing 1s 0.2s ease both;
  -moz-animation: swing 1s 0.2s ease both;
  p {
    color: red;
    font-weight: bold;
    letter-spacing: 2px;
    border-radius: 20px;
  }
}
@-webkit-keyframes swing {
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transform-origin: top center;
  }
  20% {
    -webkit-transform: rotate(15deg);
  }
  40% {
    -webkit-transform: rotate(-10deg);
  }
  60% {
    -webkit-transform: rotate(5deg);
  }
  80% {
    -webkit-transform: rotate(-5deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
  }
}
@-moz-keyframes swing {
  20%,
  40%,
  60%,
  80%,
  100% {
    -moz-transform-origin: top center;
  }
  20% {
    -moz-transform: rotate(15deg);
  }
  40% {
    -moz-transform: rotate(-10deg);
  }
  60% {
    -moz-transform: rotate(5deg);
  }
  80% {
    -moz-transform: rotate(-5deg);
  }
  100% {
    -moz-transform: rotate(0deg);
  }
}
.icon {
  font-size: 21px;
  color: #736fe6;
  transform: rotate(-90deg);
}

.footer {
  background-color: white;
  border-radius: 10px;
}
.min_footer {
  width: 500px;
  height: 500px;
}
.max_footer {
  width: 800px;
  height: 800px;
}
.chat_all {
  width: 100%;
  height: 100%;
  position: relative;
}
.chat_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 8%;
  max-height: 35px;
  color: #736fe6;
  border-radius: 10px 10px 0 0;
  padding-left: 10px;
  span {
    margin: 0 5px;
    cursor: pointer;
  }
}
.chat_content {
  width: 100%;
  height: 84%;
  margin-bottom: 44px;
  overflow-y: scroll;
  // border: 1px solid red;
  .message_ul {
    li {
      display: flex;
      align-items: center;
      margin-top: 10px;
      width: 98%;
      margin: 5px auto;
      img {
        width: 50px;
        height: 50px;
      }
      p {
        max-width: 75%;
        color: #000;
        margin-left: 5px;
        padding: 6px;
        border-radius: 5px;
        position: relative;
        margin-top: 0.55em;
      }
    }
    .left_li {
      text-align: left;
      p {
        background: #f1f1f1;
      }
    }
    .right_li {
      text-align: right;
      justify-content: flex-end;
      p {
        color: #fff;
        background: #0096ff;
      }
    }
  }
}
::-webkit-scrollbar {
  display: none;
}
.chat_bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 9%;
  max-height: 44px;
  // border-top: 1px solid blue;
  padding-top: 2px;
}
.chat_bottom .bottom_ne {
  //  width: 15%;
}
.chat_bottom .bottom_content {
  margin-top: 1px;
  // width: 65%;
}
.chat_bottom .bottom_button {
  height: 41px;
  margin-left: 1%;
  // width: 20%;
}
input.el-input__inner {
  border-radius: 18px !important;
}

.chat_all .chat_bottom input.el-input__inner {
  border-radius: 18px !important;
}
.chat_content .message_ul li[data-v-7ee9faf6] {
  align-items: flex-start !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ChatGpt/index.vue